import { useState, useEffect, useRef } from 'react';
import {
  fetchPersonalInformation,
  fetchAddressInformation,
  fetchBeneficiariesInformation,
  addBeneficiary,
  fetchMifielInformation
} from 'src/store/Profile/profile.slice';
import {
  PersonalInformationContainer,
  Banner,
  Options,
  AccountState,
  Option
} from './myProfile.styles';
import GeneralInfo from './generalInfo/generalInfo';
import Address from './address/address';
import Beneficiaries from './beneficiaries/beneficiaries';
import ProfessionalInfo from './professionalInfo/professionalInfo';
import { useDispatch, useSelector } from 'react-redux';
import ContractsInfo from 'src/views/investor/Dashboard/myProfile/contractsInfo/contractInfo';

export default function MyProfile() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const personalInformation = useSelector((state) => state.profile.personalInformation);
  const addressInformation = useSelector((state) => state.profile.addressInformation);
  const beneficiariesInformation = useSelector((state) => state.profile.beneficiariesInformation);
  const mifielInformation = useSelector((state) => state.profile.mifielInformation);

  const [generalInfo, setGeneralInfo] = useState(true);
  const [address, setAddress] = useState(false);
  const [professionalInfo, setProfessionalInfo] = useState(false);
  const [beneficiaries, setBeneficiaries] = useState(false);
  const [contracts, setContracts] = useState(false);
  const [accountState, setAccountState] = useState(false);
  const [refreshData, setRefreshData] = useState(false);

  useEffect(() => {
    if (user.id) {
      dispatch(fetchPersonalInformation(user.id));
      dispatch(fetchAddressInformation(user.id));
      dispatch(fetchBeneficiariesInformation(user.id));
      dispatch(fetchMifielInformation(user.id));
    }
  }, [user.id, dispatch]);

  const onAddBeneficiary = (beneficiary) => {
    dispatch(addBeneficiary(beneficiary));
  };

  const showGeneralInfo = () => {
    setGeneralInfo(true);
    setAddress(false);
    setProfessionalInfo(false);
    setBeneficiaries(false);
    setContracts(false);
    setAccountState(false);
  };

  const showAddress = () => {
    setGeneralInfo(false);
    setAddress(true);
    setProfessionalInfo(false);
    setBeneficiaries(false);
    setContracts(false);
    setAccountState(false);
  };

  const showProfessionalInfo = () => {
    setGeneralInfo(false);
    setAddress(false);
    setProfessionalInfo(true);
    setBeneficiaries(false);
    setContracts(false);
    setAccountState(false);
  };

  const showBeneficiaries = () => {
    setGeneralInfo(false);
    setAddress(false);
    setProfessionalInfo(false);
    setBeneficiaries(true);
    setContracts(false);
    setAccountState(false);
  };

  const showContracts = () => {
    setGeneralInfo(false);
    setAddress(false);
    setProfessionalInfo(false);
    setBeneficiaries(false);
    setContracts(true);
    setAccountState(false);
  };

  const showAccountState = () => {
    setGeneralInfo(false);
    setAddress(false);
    setProfessionalInfo(false);
    setBeneficiaries(false);
    setContracts(false);
    setAccountState(true);
  };

  return (
    <PersonalInformationContainer>
      <Banner>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_dash_my_profile_banner.png`}
            alt="Finsphera icono"
          />
        </figure>
        <h2>Mi perfil</h2>
        <p>
          En tu perfil podrás completar tus datos como inversionista FinSphera y así realizar
          acciones en la plataforma.
        </p>
      </Banner>
      <Options>
        <Option isSelected={generalInfo} onClick={showGeneralInfo}>
          Información General
        </Option>
        <Option isSelected={address} onClick={showAddress}>
          Dirección
        </Option>
        <Option isSelected={professionalInfo} onClick={showProfessionalInfo}>
          Información Profesional
        </Option>
        <Option isSelected={beneficiaries} onClick={showBeneficiaries}>
          Beneficiarios
        </Option>
        <Option isSelected={contracts} onClick={showContracts}>
          Contratos
        </Option>
        <Option isSelected={accountState} onClick={showAccountState}>
          Estados de Cuenta
        </Option>
      </Options>
      {generalInfo && <GeneralInfo personalInformation={personalInformation} />}
      {address && <Address addressInformation={addressInformation} />}
      {professionalInfo && <ProfessionalInfo personalInformation={personalInformation} />}
      {beneficiaries && (
        <Beneficiaries
          beneficiariesInformation={beneficiariesInformation}
          onRefreshData={() => dispatch(fetchBeneficiariesInformation(user.id))}
          addBeneficiary={onAddBeneficiary}
        />
      )}
      {contracts && <ContractsInfo mifielInformation={mifielInformation} />}
      {accountState && (
        <AccountState>
          <div>
            <div>
              <p>Seleccione el año:</p>
              <select name="year">
                <option value="none">Seleccionar:</option>
              </select>
            </div>
            <div>
              <p>Seleccione el mes:</p>
              <select name="month">
                <option value="none">Seleccionar:</option>
              </select>
            </div>
          </div>
          <div>
            <p>¿Cómo quieres solicitar tu código?</p>
            <div>
              <select name="year">
                <option value="none">Seleccionar:</option>
                <option value="sms">Enviando un SMS / Authy</option>
                <option value="call">Haciendo una llamada</option>
              </select>
              <button>Enviar código</button>
            </div>
          </div>
        </AccountState>
      )}
    </PersonalInformationContainer>
  );
}
